(function() {
  function init() {
    var cards = document.querySelectorAll('.noxor-cc__card');
    if (!cards.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var idx = Array.from(cards).indexOf(entry.target);
        setTimeout(function() {
          entry.target.classList.add('noxor-cc__card--visible');
        }, idx * 200);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    cards.forEach(function(card) { observer.observe(card); });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
